import { settingsService } from '@/services/settingsService'
import * as Sentry from '@sentry/vue'
import type { App } from 'vue'
import type { Router } from 'vue-router'

export default function (app: App, router: Router) {
  Sentry.init({
    app,
    dsn: settingsService.isDevelopment
      ? ''
      : 'https://91b44a7419874082ecdf0ae7662d2e24@o932979.ingest.us.sentry.io/4507964653305856',
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.browserSessionIntegration(),
      Sentry.vueIntegration({
        tracingOptions: {
          trackComponents: true,
        },
      }),
    ],
    // Tracing
    tracesSampleRate: 0.25,
    // Metadata
    environment: import.meta.env.VITE_TYPE,
    release: import.meta.env.VITE_RELEASE,
  })
}
